import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

const TemplateWrapper = ({ children }) => {
  return (
    <div className="antialiased text-gray-900">
      <div className="container mx-auto bg-white shadow-md">
        <Navbar />
        <div className="px-4 py-6">
          {children}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default TemplateWrapper
